import { useCallback, useEffect, useState } from "react";
import { AutomaticSummarizationContext } from "../contexts/AutomaticSummarizationContext";
import axios from "axios";
import { useSelector } from "react-redux";

export const AutomaticSummarizationProvider = ({ children }) => {
  const [
    isAutomaticallyGenerateSummaryEnabled,
    setIsAutomaticallyGenerateSummaryEnabled,
  ] = useState(false);
  const [firstTime, setFirstTime] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const { data } = useSelector((state) => state.Login);

  const handleUpdate = useCallback(async (value, updateActualValue = true) => {
    setIsLoading(true);
    await axios
      .put(`${process.env.REACT_APP_API_URL}/user/metadata`, {
        key: "is_automatically_generate_summary_enabled",
        value: value.toString(),
      })
      .then(() => {
        if (updateActualValue) {
          setIsAutomaticallyGenerateSummaryEnabled(value);
          setFirstTime(false);
        }
      })
      .finally(() => setIsLoading(false));
  }, []);

  const handleGetValue = useCallback(async ({ isAutomaticSummarizationEnabled = true }) => {
    if(!isAutomaticSummarizationEnabled) return setIsLoading(false)
      
    await axios
      .get(
        `${process.env.REACT_APP_API_URL}/user/metadata?key=is_automatically_generate_summary_enabled`
      )
      .then((response) =>
        setIsAutomaticallyGenerateSummaryEnabled(
          response.data.data.value === "true"
        )
      )
      .catch(() => handleUpdate(true, false))
      .finally(() => setIsLoading(false));
  }, [handleUpdate]);

  const handleCheckIfValueExists = useCallback(async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/user/metadata?key=is_automatically_generate_summary_enabled`
    );
    if (response.status === 404) setFirstTime(true);
    else setFirstTime(false);
  }, []);

  useEffect(() => {
    if(!data) return
    handleCheckIfValueExists();
  }, [handleCheckIfValueExists, data]);

  return (
    <AutomaticSummarizationContext.Provider
      value={{
        isAutomaticallyGenerateSummaryEnabled,
        save: handleUpdate,
        refresh: handleGetValue,
        firstTime,
        isLoading,
      }}
    >
      {children}
    </AutomaticSummarizationContext.Provider>
  );
};
